import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=40a7527e&scoped=true&lang=html&"
import script from "./CommonTitle.vue?vue&type=script&lang=js&"
export * from "./CommonTitle.vue?vue&type=script&lang=js&"
import style0 from "./CommonTitle.vue?vue&type=style&index=0&id=40a7527e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7527e",
  null
  
)

export default component.exports